/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type VectorIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function VectorIcon(props: VectorIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 44 44"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M33.25 33.25c-2.287 0-4.399-.743-6.125-1.989v9.864a.876.876 0 0 0 1.267.783l4.858-2.43 4.859 2.43a.87.87 0 0 0 .85-.038.88.88 0 0 0 .416-.745v-9.864a10.43 10.43 0 0 1-6.125 1.989"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M33.25 14c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75S42 27.575 42 22.75 38.075 14 33.25 14"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M33.25 1.75H2.625a.875.875 0 0 0-.875.875v33.25c0 .483.391.875.875.875h22.75v-7.078a10.45 10.45 0 0 1-2.625-6.922c0-5.79 4.71-10.5 10.5-10.5.296 0 .585.02.875.045v-9.67a.875.875 0 0 0-.875-.875M16.625 28h-8.75a.875.875 0 1 1 0-1.75h8.75a.875.875 0 1 1 0 1.75m0-7.875h-8.75a.875.875 0 1 1 0-1.75h8.75a.875.875 0 1 1 0 1.75m5.25-7.875h-14a.875.875 0 1 1 0-1.75h14a.875.875 0 1 1 0 1.75"
        }
      ></path>

      <path
        stroke={"currentColor"}
        strokeWidth={"1.75"}
        d={
          "m26.25 29.55 1.06.765a10 10 0 0 1-1.06-.97v.206zm-2.321-9.202v-.001zM35 13.248l-.595-.052c4.765.573 8.47 4.637 8.47 9.554a9.61 9.61 0 0 1-3.685 7.565l1.06-.764v11.574a1.75 1.75 0 0 1-.83 1.488 1.75 1.75 0 0 1-1.702.077l-4.468-2.234-4.467 2.234-.005.003a1.75 1.75 0 0 1-2.528-1.568v-3.5H2.625a1.75 1.75 0 0 1-1.75-1.75V2.625c0-.966.782-1.75 1.75-1.75H33.25c.968 0 1.75.784 1.75 1.75z"
        }
      ></path>
    </svg>
  );
}

export default VectorIcon;
/* prettier-ignore-end */
